import { countryCityConstants } from "../constants/countryCityConstants";

const initialState = {
  sending: false,
  cityResponse: {},
  error: "",
  fetching: "",
  states: [],
  citiesList: {},
  countries: [],
  cityDetailsByState: [],
  cscitems: [],
  deletedCity: {},
  updatedCity: {},
  timezones: {},
  citiesData: [],
  fetchingState: false,
  fetchCity: false,
  fetchingCities: false,
  sendingCityData: false,
  fetchingTimezone: false,
  cityUpdate: {}
};

export default function countrycityReducer(state = initialState, action) {
  switch (action.type) {
    case countryCityConstants.ADD_CITY_REQUEST:
      return {
        ...state,
        sendingCityData: true
      };
    case countryCityConstants.ADD_CITY_SUCCESS:
      return {
        ...state,
        sendingCityData: false,
        cityResponse: action.city,
        error: ""
      };
    case countryCityConstants.ADD_CITY_FAILURE:
      return {
        ...state,
        sendingCityData: false,
        error: action.error
      };
    case countryCityConstants.FETCH_COUNTRIES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case countryCityConstants.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.countries.data,
        error: ""
      };
    case countryCityConstants.FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.FETCH_STATE_REQUEST:
      return {
        ...state,
        fetchingState: true
      };
    case countryCityConstants.FETCH_STATE_SUCCESS:
      return {
        ...state,
        fetchingState: false,
        states: action.states.data,
        error: ""
      };
    case countryCityConstants.FETCH_STATE_FAILURE:
      return {
        ...state,
        fetchingState: false,
        error: action.error
      };
    case countryCityConstants.FETCH_CITIES_REQUEST:
      return {
        ...state,
        fetchingCities: true
      };
    case countryCityConstants.FETCH_CITIES_SUCCESS:
      return {
        ...state,
        fetchingCities: false,
        citiesList: action.cities.data,
        citiesData: action.cities.data.data,
        cityResponse: {},
        cityUpdate: {},
        error: ""
      };
    case countryCityConstants.FETCH_CITIES_FAILURE:
      return {
        ...state,
        fetchingCities: false,
        error: action.error
      };
    case countryCityConstants.DELETE_CITY_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case countryCityConstants.DELETE_CITY_SUCCESS:
      return {
        ...state,
        deletedCity: action.city,
        error: ""
      };
    case countryCityConstants.DELETE_CITY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.GET_CITY_DETAILS_REQUEST:
      return {
        ...state,
        fetchCity: true
      };
    case countryCityConstants.GET_CITY_DETAILS_SUCCESS:
      return {
        ...state,
        fetchCity: false,
        cityDetails: action.cityDetails,
        error: ""
      };
    case countryCityConstants.GET_CITY_DETAILS_FAILURE:
      return {
        ...state,
        fetchCity: false,
        error: action.error
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_SUCCESS:
      return {
        ...state,
        cityDetailsByState: action.cityDetailsByState.data,
        error: ""
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.UPDATE_CITY_REQUEST:
      return {
        ...state,
        sendingCityData: true
      };
    case countryCityConstants.UPDATE_CITY_SUCCESS:
      return {
        ...state,
        cityUpdate: action.updatedCity,
        sendingCityData: false,
        error: ""
      };
    case countryCityConstants.UPDATE_CITY_FAILURE:
      return {
        ...state,
        error: action.error,
        sendingCityData: false
      };
    case countryCityConstants.FETCH_TIMEZONE_REQUEST:
      return {
        ...state,
        fetchingTimezone: true
      };
    case countryCityConstants.FETCH_TIMEZONE_SUCCESS:
      return {
        ...state,
        fetchingTimezone: false,
        timezones: action.timezone.data,
        error: ""
      };
    case countryCityConstants.FETCH_TIMEZONE_FAILURE:
      return {
        ...state,
        fetchingTimezone: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/countryCityReducers.js